var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedItineraries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.04 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.93h52.04V69.5H1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.85V1.5h52.04v60.57h-8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72 16.89h34.8V51.3H9.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.11 41.11 10.56-11.35 12.91 12.52m-5.47-5.47 8.61-6.26 7.82 6.26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.65,
    cy: 24.87,
    r: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.12 58.15H33.2m-23.08 4.7h29.72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedItineraries);
export default __webpack_public_path__ + "static/media/savedItineraries.3ab37b64e09832028f7d65cd316a1aac.svg";
export { ForwardRef as ReactComponent };